import { useMatrixColumnsContext } from '@app/components/products/ProductMatrix/context';
import { cn } from '@app/utils/cn';
import { useTranslation } from 'react-i18next';

import { RegularHeaderCell } from '../MatrixCells';
import { PinnableSummaryCell } from '../MatrixCells/PinnableSummaryCell';

export const TotalsSummaryHeadCell = () => {
  const { t } = useTranslation(['common', 'totals']);
  const { isTotalsColumnPinned } = useMatrixColumnsContext();

  return (
    <PinnableSummaryCell>
      <RegularHeaderCell
        className={cn('rounded-regular border-2 border-white bg-white px-2 text-right transition-colors', {
          'sticky right-0': isTotalsColumnPinned,
        })}
      >
        {t('totals:total_one')}
      </RegularHeaderCell>
    </PinnableSummaryCell>
  );
};
